// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/product-cs-offering-comparative-view/product-cs-offering-comparative-view.component.scss
// module id = 787
// module chunks = 0